import React, { useMemo } from 'react'
//import { Map } from '@evertel/web/ui'
import Wrapper from './Wrapper'
import { Text, Link } from '@react-pdf/renderer'
import { MapValue, normalizeMapValue, hasValidCoords } from '@evertel/document'

interface MapReadWidgetProps {
    value?: MapValue
    title?: string
    description?: string
}

const MapReadWidget: React.FC<MapReadWidgetProps> = ({
    value,
    title,
    description
}) => {

    const normalizedValue = useMemo(() => normalizeMapValue(value), [value])

    const displayText = normalizedValue?.address || normalizedValue?.displayName || ''
    const hasCoords = hasValidCoords(normalizedValue)
    const hasContent = displayText.length > 0

    // build a Google Maps link if we have coords, otherwise just use address as query
    const mapLink = hasCoords
        ? `https://maps.google.com/?q=${normalizedValue.geometry.location.lat},${normalizedValue.geometry.location.lng}`
        : `https://maps.google.com/?q=${encodeURIComponent(displayText)}`

    return (
        <Wrapper
            value={normalizedValue}
            title={title}
            description={description}>
            {!hasContent ?
                <Text>
                    ---
                </Text>
                :
                <Link
                    src={mapLink}
                    style={{
                        color: 'blue'
                    }}>
                    {displayText}
                </Link>
            }

            {/* {(address && geometry) &&
                <View style={{height: 200}}>
                    <Map
                        apiKey={import.meta.env.VITE_GOOGLE_API_KEY}
                        center={geometry.location}
                        zoom={11}
                    />
                </View>
            } */}
        </Wrapper>
    )
}

export default MapReadWidget
